.modal {
  width: 500px;
}

.modal-body {
  font-size: 15px;
  line-height: normal;
}
